import { AfterViewInit, Component, Inject, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Account } from '@models/account';

import { User } from '@models/user';
import { AccountService } from '@services/account.service';
import { UserService } from '@services/user.service';

export class UserAccountData {
    user: User;
    accounts: Account[];
}

@Component({
    selector: 'cp-user-accounts',
    templateUrl: './user-accounts.component.html',
    styleUrls: ['./user-accounts.component.less'],
    standalone: false
})
export class UserAccountsComponent implements OnInit, AfterViewInit {
    displayColumns: string[] = ['accountNumber', 'accountName', 'accountLocation'];

    user: User;
    accounts: Account[] = [];
    availableAccounts: Account[] = [];
    searchCriteria: string;

    currentSelected: Account;
    availableSelected: Account;

    currentDataSource: MatTableDataSource<Account>;
    availableDataSource: MatTableDataSource<Account>;

    @ViewChildren(MatPaginator) paginators = new QueryList<MatPaginator>();

    get UserFullName(): string {
        if (this.user) {
            return this.user.FirstName + ' ' + this.user.LastName;
        }
        return '';
    }

    get currentAccountSelected(): boolean {
        return (this.currentSelected !== undefined && this.currentSelected !== null);
    }

    get availableAccountSelected(): boolean {
        return (this.availableSelected !== undefined && this.availableSelected !== null);
    }

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: UserAccountData,
        private _userService: UserService,
        private _dialogRef: MatDialogRef<UserAccountsComponent>,
        private _accountService: AccountService
    )
    {
        this.user = data.user;
        this.accounts = data.accounts;

    }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        this._accountService.getAccountList().subscribe({
            next: (accounts: Account[]) => {
                this.availableAccounts = accounts;

                this.currentDataSource = new MatTableDataSource();
                if (this.accounts) {
                    if (!this.accounts) {
                        this.accounts = [];
                    }
                    this.currentDataSource.data = this.accounts.slice();
                }
                this.availableDataSource = new MatTableDataSource(this.availableAccounts);

                this.setupDataSources();
            }
        });

        // this.setupDataSources();
    }

    removeFromCurrent(account: Account): void {
        if (!account) {
            account = this.currentSelected;
        }
        var idx: number = this.accounts.indexOf(account);
        this.accounts.splice(idx, 1);
        this.currentSelected = null;
        this.setupDataSources();
    }

    addToCurrent(account: Account | null): void {
        if (!account) {
            account = this.availableSelected;
        }
        if (!this.accounts) {
            this.accounts = [];
        }

        if (!this.accounts.find((a => a.AccountNumber === account.AccountNumber))) {
            this.accounts.push(account);
        }
        this.availableSelected = null;
        this.setupDataSources();
    }

    async onSave(): Promise<void> {
        if (await this._userService.updateUserAccounts(this.user, this.accounts)) {
            this._dialogRef.close(this.accounts);
        } else {
            alert('Error updating user accounts');
        }
    }

    onCancel(): void {
        this._dialogRef.close();
        // TODO
    }

    toggleCurrent(account: Account): void {
        if (account) {
            if (this.currentSelected) {
                this.currentSelected = null;
            } else {
                this.currentSelected = account;
            }
        }
    }

    toggleAvailable(account: Account): void {
        if (account) {
            if (this.availableSelected) {
                this.availableSelected = null;
            } else {
                this.availableSelected = account;
            }
        }
    }

    searchAccounts(): void {
        this._accountService
            .getAccountList(this.searchCriteria)
            .subscribe({
                next: (accounts: Account[]) => {
                    this.availableAccounts = accounts;
                    this.availableDataSource.data = this.availableAccounts;
                },
                error: (error: any) => {
                    // this.handleError(error);
                }
            });
    }

    private setupDataSources(): void {
        if (this.paginators) {
            if (this.accounts) {
                this.currentDataSource.data = this.accounts;
                this.currentDataSource.paginator = this.paginators.toArray()[0];
                this.currentDataSource.paginator.length = this.accounts.length;
            }

            if (this.availableAccounts) {
                this.availableDataSource.data = this.availableAccounts;
                this.availableDataSource.paginator = this.paginators.toArray()[1];
                this.availableDataSource.paginator.length = this.availableAccounts.length;
            }
        }
    }
}
